module.exports = __webpack_public_path__ + "static/media/294266.4f5cfbbd.png";